import { render, staticRenderFns } from "./CompanyDetailWidget.vue?vue&type=template&id=44882307&scoped=true&"
import script from "./CompanyDetailWidget.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailWidget.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetailWidget.vue?vue&type=style&index=0&id=44882307&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44882307",
  null
  
)

export default component.exports